import React from 'react'
import { ConfirmDialog } from 'primereact/confirmdialog'
import { FaInfo } from 'react-icons/fa6'
import CustomButton from './CustomButton'
import Spinner from './Spinner'
import { useTranslation } from 'react-i18next'

export default function ConfirmationModal({
  message = 'Areyousureyouwanttoproceed?Thisactioncannotbeundone.',
  header,
  Icon = FaInfo,
  onAccept,
  onReject,
  visible,
  setVisible,
  rejectLabel,
  acceptLabel,
  isLoading = false,
  position = 'center'
}) {
  const { t } = useTranslation()

  const headerTemplate = () => {
    return (
      <div className='w-full flex flex-col items-center justify-center'>
        <div className='icon-bg-container !h-[40px] !w-[40px]'>
          <Icon size={20} className='text-primary' />
        </div>
        <h5 className='text-20-gray !font-semibold mt-2'>
          {t(header) || t('Confirmation')}
        </h5>
      </div>
    )
  }

  const footerTemplate = () => {
    return (
      <div className='flex items-center w-full justify-end gap-3'>
        <CustomButton
          disabled={isLoading}
          buttonType='reset'
          label={t(rejectLabel)}
          icon='pi pi-times'
          className='cancel-btn'
          type='button'
          onClick={() => {
            setVisible(false)
            if (onReject) onReject()
          }}
        />
        {
          onAccept && (
            <CustomButton
              disabled={isLoading}
              buttonType='primary'
              icon='pi pi-check'
              label={
                isLoading ? (
                  <span className='flex items-center gap-2'>
                    {t('Loading')} <Spinner />
                  </span>
                ) : (
                  t(acceptLabel)
                )
              }
              className='confirm-btn'
              type='button'
              onClick={() => {
                if (onAccept) onAccept()
              }}
            />
          )
        }
      </div>
    )
  }

  return (
    <ConfirmDialog
      position={position}
      header={headerTemplate}
      visible={visible}
      group='declarative'
      onHide={() => setVisible(false)}
      message={t(message)}
      accept={onAccept}
      reject={onReject}
      pt={{
        root: {
          className:
            'w-4/5 md:w-2/3 lg:w-[550px] px-0 pt-4 overflow-auto bg-white'
        },
        header: { className: '!p-2' },
        footer: { className: 'px-2 !py-3 border-t border-t-gray-200 mt-4' },
        content: {
          className:
            'p-3 text-center ml-0 text-16-gray flex items-center justify-center'
        },
        closeButton: {
          className: 'hover:!bg-black/20 !outline-none !shadow-none'
        },
        closeButtonIcon: { className: '!text-white' }
      }}
      footer={footerTemplate}
    />
  )
}
